import * as React from 'react';
import PropTypes from 'prop-types';

function SvgShopigy({ height, width }) {
  return (
    <svg
      height={height}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 28.6"
    >
      <path
        d="M11.3 1c.2 0 .3.1.5.2-1.2.5-2.4 1.8-3 4.6l-2.2.6c.7-2 2.1-5.4 4.7-5.4zm1.1 1c.2.6.4 1.3.4 2.4v.2l-2.9.8c.6-2.1 1.6-3 2.5-3.4zM15 3.8l-1.3.4v-.3c0-.9-.1-1.6-.3-2.2.7.2 1.3 1.1 1.6 2.1zm6.5 1.6c0-.1-.1-.2-.2-.2-.2 0-2.3-.2-2.3-.2s-1.5-1.5-1.7-1.6c-.2-.2-.5-.1-.6-.1 0 0-.3.1-.8.3C15.4 2.2 14.5.9 13 .9h-.1c-.4-.6-1-.8-1.5-.8C7.8 0 6.1 4.5 5.5 6.8c-.8.2-1.6.5-2.5.8-.8.2-.8.3-.9 1C2 9.1 0 24.9 0 24.9l15.9 3 8.6-1.9s-3-20.4-3-20.6z"
        fill="#8db849"
      />
      <path
        d="M21.2 5.2C21.1 5.2 19 5 19 5s-1.5-1.5-1.7-1.6c-.1-.1-.1-.1-.2-.1l-1.2 24.6 8.6-1.9s-3-20.4-3-20.6c0-.1-.2-.2-.3-.2"
        fill="#5a863e"
      />
      <path
        d="M13 10l-1.1 3.2s-.9-.5-2.1-.5c-1.7 0-1.8 1-1.8 1.3 0 1.4 3.8 2 3.8 5.4 0 2.7-1.7 4.4-4 4.4-2.7 0-4.1-1.7-4.1-1.7l.7-2.4s1.4 1.2 2.6 1.2c.8 0 1.1-.6 1.1-1.1 0-1.9-3.1-2-3.1-5.1 0-2.6 1.9-5.1 5.6-5.1 1.7-.1 2.4.4 2.4.4"
        fill="#fffffe"
      />
      <path
        d="M34.6 15.9c-.9-.5-1.3-.9-1.3-1.4 0-.7.6-1.1 1.6-1.1 1.1 0 2.1.5 2.1.5l.8-2.4s-.7-.6-2.8-.6c-3 0-5 1.7-5 4.1 0 1.4 1 2.4 2.2 3.1 1 .6 1.4 1 1.4 1.6 0 .6-.5 1.2-1.5 1.2-1.4 0-2.8-.7-2.8-.7l-.8 2.4s1.2.8 3.3.8c3 0 5.2-1.5 5.2-4.2 0-1.5-1.1-2.6-2.4-3.3m12.1-5.1c-1.5 0-2.7.7-3.6 1.8l1.3-6.8H41l-3.3 17.3h3.4l1.1-5.9c.4-2.2 1.6-3.6 2.7-3.6.8 0 1.1.5 1.1 1.3 0 .5 0 1-.1 1.5l-1.3 6.8H48l1.3-7c.1-.7.2-1.6.2-2.2 0-2-1-3.2-2.8-3.2m8.7 9.9c-1.2 0-1.6-1-1.6-2.2 0-1.9 1-5.1 2.8-5.1 1.2 0 1.6 1 1.6 2 0 2.2-1 5.3-2.8 5.3zm1.7-9.9c-4.1 0-6.8 3.7-6.8 7.8 0 2.6 1.6 4.7 4.7 4.7 4 0 6.7-3.6 6.7-7.8 0-2.4-1.4-4.7-4.6-4.7zm10 10c-.9 0-1.4-.5-1.4-.5l.6-3.2c.4-2.1 1.5-3.5 2.7-3.5 1 0 1.4 1 1.4 1.9-.1 2.2-1.4 5.3-3.3 5.3zm3.3-10c-2.3 0-3.6 2-3.6 2L67 11h-3c-.1 1.2-.4 3.1-.7 4.5l-2.4 12.4h3.4l.9-5h.1s.7.4 2 .4c4 0 6.6-4.1 6.6-8.2 0-2.2-1-4.3-3.5-4.3zM78.7 6c-1.1 0-1.9.9-1.9 2 0 1 .6 1.7 1.6 1.7 1.1 0 2-.7 2-2 0-1-.7-1.7-1.7-1.7M74 23.1h3.4l2.3-12h-3.4l-2.3 12zm14.3-12h-2.4l.1-.6c.2-1.2.9-2.2 2-2.2.6 0 1.1.2 1.1.2l.7-2.7s-.6-.3-1.8-.3c-1.2 0-2.4.3-3.3 1.1-1.2 1-1.7 2.4-2 3.8l-.1.6H81l-.5 2.6h1.6l-1.8 9.5h3.4l1.8-9.5h2.3l.5-2.5zm8.1 0s-2.1 5.3-3.1 8.2c-.1-.9-.8-8.2-.8-8.2h-3.6l2 11c0 .2 0 .4-.1.6-.4.8-1.1 1.5-1.8 2-.6.5-1.4.8-1.9 1l.9 2.9c.7-.1 2.1-.7 3.3-1.8 1.5-1.4 3-3.7 4.4-6.7l4.1-8.9-3.4-.1z"
        fill="#1a1919"
      />
    </svg>
  );
}

SvgShopigy.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
};

SvgShopigy.defaultProps = {
  height: 15,
  width: 60,
};

export default SvgShopigy;
